import {
  BondPriceComponent,
  CouponPaymentComponent,
  MaturityDateComponent,
  MinimumInvestmentComponent,
  OutstandingAmountComponent,
  YearsToMaturityComponent,
  YieldComponent,
} from "@goodfill/domain-properties-components";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { bondProspectusURL } from "../../../assets/SEC-prospectus-URLs";
import { Link } from "../../../ui-components/Link/Link";
import { Field, Flex } from "../../../ui-components";
import { PricedBond } from "../PricedBond";
import { GrayBox } from "../../../ui-components/GrayBox";
import { calculateDiffYears } from "@goodfill/date";
import { InfoTooltip } from "../../../ui-components/tooltip/InfoTooltip";
import { TIMEZONE_NEY_YORK } from "../../../locale/timezone";

export const BondDetailBondParams = ({ pricedBond, tradeDate }: { pricedBond: PricedBond; tradeDate: DateTime }) => {
  const { t } = useTranslation();

  const prospectusUrl = bondProspectusURL[`${pricedBond.bondIdCusip}`];

  const onClickProspectus = () => {
    window.open(prospectusUrl);
  };

  return (
    <GrayBox className="md:p-4 p-2">
      <div className="grid lg:grid-cols-3 grid-cols-2 md:gap-4 gap-2">
        <Field label={"Ticker"} textAlign="left" labelClassName="whitespace-unset-important">
          {pricedBond.issuerTicker}
        </Field>

        <Field label={"Coupon"} textAlign="left" labelClassName="whitespace-unset-important">
          <CouponPaymentComponent value={pricedBond.couponPayment} />
        </Field>

        <Field label={t("bond.maturityDate")} textAlign="left" labelClassName="whitespace-unset-important">
          <MaturityDateComponent value={pricedBond.maturityDate} timezone={TIMEZONE_NEY_YORK} />
        </Field>

        <Field
          label={
            <>
              {t("bond.offerYield")} <InfoTooltip text="Actual Investment = Order Price Post-Fee (%) x Face Amount" />
            </>
          }
          textAlign="left"
          labelClassName="whitespace-unset-important"
        >
          <YieldComponent value={pricedBond.askYield} />
        </Field>

        <Field
          label={
            <>
              {t("bond.offerPrice")}{" "}
              <InfoTooltip text="Actual Investment = Order Price Post-Fee (%) x Face Amount  " />
            </>
          }
          textAlign="left"
          labelClassName="whitespace-unset-important"
        >
          <BondPriceComponent value={pricedBond.askPrice} />
        </Field>

        <Field label={t("bond.minimumPiece")} textAlign="left" labelClassName="whitespace-unset-important">
          <MinimumInvestmentComponent value={pricedBond.minimumPiece.amount} />
        </Field>
        <Field label={t("bond.outstandingAmount")} textAlign="left" labelClassName="whitespace-unset-important">
          <OutstandingAmountComponent value={pricedBond.outstandingAmount.amount} />
        </Field>

        <Field label={t("bond.ratings.S&P")} textAlign="left" labelClassName="whitespace-unset-important">
          {pricedBond.ratings.sp}
        </Field>

        <Field label={t("bond.ratings.Moody")} textAlign="left" labelClassName="whitespace-unset-important">
          {pricedBond.ratings.moodys}
        </Field>

        <Field label="Years to Maturity" textAlign="left" labelClassName="whitespace-unset-important">
          <YearsToMaturityComponent value={calculateDiffYears(pricedBond.maturityDate, tradeDate)} />
        </Field>

        {prospectusUrl && (
          <div className="whitespace-unset-important flex justify-end my-2 md:my-4">
            <div className="flex">
              <Link onClick={onClickProspectus} icon>
                Prospectus
              </Link>
            </div>
          </div>
        )}
      </div>
    </GrayBox>
  );
};
